import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const FlyingBeeBy2s = () => {
  const [qIndex, setQIndex] = useState(0);
  const [answer, setAnswer] = useState(8);
  const [feedback, setFeedback] = useState('');

  const correctSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg'));
  const wrongSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'));

  const questions = [
    { q: "If Bee starts at 0 and flies 4 flowers ahead, where is she?", a: 8 },
    { q: "Quick! 2 more than 14?", a: 16 },
    { q: "Which flower has a number ending in 2?", a: [2,12,22,32] },
    { q: "If Bee skips 3 flowers starting from 6, where will she land?", a: 12 },
    { q: "Bee flies to the 15th flower. Where is she?", a: 28 },
  ];

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      backgroundColor: '#f3e5f5',
      textAlign: 'center',
      padding: '2rem',
      minHeight: '100vh',
      boxSizing: 'border-box'
    },
    h1: {
      color: '#9c27b0',
      marginBottom: '1.5rem',
      fontSize: '2rem'
    },
    question: {
      margin: '2rem 0',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      maxWidth: '600px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    field: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginTop: '2rem',
      gap: '0.8rem',
      maxWidth: '90vw',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    flower: {
      width: 'min(14vw, 70px)',
      height: 'min(14vw, 70px)',
      borderRadius: '50%',
      backgroundColor: '#e1bee7',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      border: '2px solid #6a1b9a',
      position: 'relative'
    },
    result: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      color: 'green',
      marginTop: '2rem',
      minHeight: '2rem'
    },
  };

  const handleAnswer = (selected) => {
  const currentAnswer = questions[qIndex].a;
  const isCorrect = Array.isArray(currentAnswer)
    ? currentAnswer.includes(selected)
    : selected === currentAnswer;

  if (isCorrect) {
    correctSound.current.play();
    setFeedback("✅ Yay! Bee landed on the right flower!");
    setTimeout(() => {
      const next = qIndex + 1;
      if (next >= questions.length) {
        setFeedback("🎉 You finished all Bee jumps! Restarting...");
        setTimeout(() => {
          setQIndex(0);  // Restart
          setFeedback('');
        }, 2000);
              const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      } else {
        setQIndex(next);
        setAnswer(questions[next]?.a || 0);
        setFeedback('');
      }
    }, 1500);
  } else {
    wrongSound.current.play();
    setFeedback("❌ Oops! Try a different flower!");
  }
};


  useEffect(() => {
    setAnswer(questions[qIndex].a);
  }, [qIndex]);

  return (
    <div style={styles.body}>
      <h2 style={styles.h1}>🐝 Flying Bee by 2s</h2>
      <p>Help Bee land on the right flower by counting by 2s!</p>

      <div style={styles.question}>
        {qIndex >= questions.length
          ? "🎉 You finished all Bee jumps!"
          : questions[qIndex].q}
      </div>

      <div style={styles.field}>
        {Array.from({ length: 21 }).map((_, i) => {
          const value = i * 2;
          const isSparkle = value % 4 === 0;
          return (
            <div
              key={value}
              style={{ ...styles.flower }}
              onClick={() => handleAnswer(value)}
            >
              {value}
              {isSparkle && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-10px',
                    right: '-10px'
                  }}
                >
                  ✨
                </span>
              )}
            </div>
          );
        })}
      </div>

      <div style={styles.result}>{feedback}</div>
    </div>
  );
};

export default FlyingBeeBy2s;
